import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer-action-buttons',
  templateUrl: './footer-action-buttons.component.html',
  styleUrls: ['./footer-action-buttons.component.scss']
})
export class FooterActionButtonsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
